module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page manage-album-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('div', _vm._l((_vm.setAlbumFilter()), function(album, index) {
    return _c('album-list', {
      key: index,
      attrs: {
        "index": index,
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "updateAccessLevelAction": _vm.closeAccessLevelConfirmDialog,
        "acceptButtonAction": _vm.acceptAlbum,
        "denyButtonAction": _vm.denyAlbum,
        "releaseButtonAction": _vm.releaseAlbum,
        "textBtnToRight": _vm.textBtnToRight
      },
      on: {
        "reRenderManageAlbum": _vm.reRenderManageAlbum
      }
    })
  })), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_access_level_confirm_dialog),
      callback: function($$v) {
        _vm.show_access_level_confirm_dialog = $$v
      },
      expression: "show_access_level_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Update Access Level")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you make this album private it will be removed from public feeds\n            and reposts. Click OK to update access level, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.privateAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAccessLevelConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_video_only_confirm_dialog),
      callback: function($$v) {
        _vm.show_video_only_confirm_dialog = $$v
      },
      expression: "show_video_only_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n            Make an album available only for live\n          ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            If you click OK, the album will be available only for live\n            video.\n          ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_album_delete_confirm_dialog = $$v
      },
      expression: "show_album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete an Album")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, your followers won't see the album any more. Click\n            OK to delete <" + _vm._s(_vm.album.name) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAlbumDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": ["upload-finish-dialog"]
    },
    model: {
      value: (_vm.showReleaseAlbumModal),
      callback: function($$v) {
        _vm.showReleaseAlbumModal = $$v
      },
      expression: "showReleaseAlbumModal"
    }
  }, [(_vm.showReleaseAlbumModal) ? _c('album-finish-modal', {
    attrs: {
      "item": _vm.releaseAlbum,
      "type": "album",
      "promote": _vm.showPromoteModal,
      "dismiss": _vm.dismissFinishDialog
    }
  }) : _vm._e()], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef7ab348","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/components/manageAlbum.vue
// module id = 1867
// module chunks = 180